import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MapAreaClickedEvent } from '../map-events.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MapAreasMapping } from '../map-styles.model';
import { ElectionType } from '@shared/clients/api.generated';

@Component({
  selector: 'valg-dk-election-map',
  templateUrl: './election-map.component.html'
})
export class ElectionMapComponent implements OnInit {
  @Input()
  public electionType!: ElectionType;

  @Input()
  public electionYear!: number;

  @Input()
  public title?: string;

  @Input()
  public regionCode?: number;

  @Input()
  public regionalLevel?: 'regions' | 'municipalities';

  @Input()
  public width = 384;

  @Input()
  public mapAreasMapping?: MapAreasMapping;

  @Output()
  public areaClicked: EventEmitter<MapAreaClickedEvent> = new EventEmitter<MapAreaClickedEvent>();

  public mapUrl!: SafeHtml;

  constructor(private readonly sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    const mapName = this.getMapName();
    this.mapUrl = this.sanitizer
      .bypassSecurityTrustResourceUrl(`assets/images/maps/${this.electionYear}/${mapName}.svg`);
  }

  private getMapName(): string {
    switch (this.electionType) {
      case ElectionType.GeneralElection:
      case ElectionType.EuropeanParliamentElection:
      case ElectionType.Referendum:
        return 'districts';
      case ElectionType.MunicipalElection:
        return 'municipalities';
      case ElectionType.RegionalElection:
        return this.getRegionsMapName();
      default:
        throw new Error(`Unknown election type: ${this.electionType}`);
    }
  }

  private getRegionsMapName(): string {
    if (this.regionalLevel == 'municipalities') {
      return `R${this.regionCode}_municipalities`;
    }

    return 'regions';
  }
}
